import { UnlockIcon, LockIcon } from "../../icons/icons";
import interact from "interactjs";

export default class DragResizeTune {
  static get isTune() {
    return true;
  }

  constructor({ api, data, config, block }) {
    this.api = api;
    this.block = block;
    this.settings = config;
    this.data = {
      draggable: {
        top: data?.draggable?.top ?? null,
        left: data?.draggable?.left ?? null,
        width: data?.draggable?.width ?? null,
        height: data?.draggable?.height ?? null,
        absolute: data?.draggable?.absolute ?? false,
        locked: data?.draggable?.locked ?? false,
        group: data?.draggable?.group ?? null,
        hide: data?.draggable?.hide ?? null,
        groupHide: data?.draggable?.groupHide ?? null,
      },
    };

    this.locked = data?.draggable.locked || false;
    this.draggableWrapper = null;
    this.readOnly = this.api.readOnly?.isEnabled;
  }

  wrap(blockContent) {
    const draggableWrapper = document.createElement("div");
    const controlWrapper = document.createElement("div");
    const draggableContent = document.createElement("div");

    const prototypeWrapper = document.createElement("div");
    this.wrapper = prototypeWrapper;
    prototypeWrapper.classList.add("draggable-wrapper");

    if (this.locked || this.readOnly) {
      prototypeWrapper.classList.add("locked");
    }

    this.draggableWrapper = prototypeWrapper;

    draggableWrapper.classList.add("draggable-wrapper");
    controlWrapper.classList.add("draggable-controls");
    draggableContent.classList.add("draggable-content");

    const dragElement = document.createElement("div");
    const rightWidthElement = document.createElement("div");
    const leftWidthElement = document.createElement("div");
    const bottomHeightElement = document.createElement("div");
    const topHeightElement = document.createElement("div");

    const topLeftElement = document.createElement("div");
    const topRightElement = document.createElement("div");
    const bottomRightElement = document.createElement("div");
    const bottomLeftElement = document.createElement("div");

    const topTooltip = document.createElement("div");
    const leftTooltip = document.createElement("div");
    const bottomTooltip = document.createElement("div");
    const rightTooltip = document.createElement("div");

    let target;
    let snapToGrid = false;
    let lockAspectRatio = false;
    const gridSize = 5;

    dragElement.classList.add("block-drag-handle");
    leftWidthElement.classList.add(
      "block-resize-width-handle-left",
      "edge-handle",
    );
    rightWidthElement.classList.add(
      "block-resize-width-handle-right",
      "edge-handle",
    );
    topHeightElement.classList.add(
      "block-resize-height-handle-top",
      "edge-handle",
    );
    bottomHeightElement.classList.add(
      "block-resize-height-handle-bottom",
      "edge-handle",
    );

    topLeftElement.classList.add(
      "block-resize-top-left-handle",
      "corner-handle",
    );
    topRightElement.classList.add(
      "block-resize-top-right-handle",
      "corner-handle",
    );
    bottomRightElement.classList.add(
      "block-resize-bottom-right-handle",
      "corner-handle",
    );
    bottomLeftElement.classList.add(
      "block-resize-bottom-left-handle",
      "corner-handle",
    );

    topTooltip.classList.add("block-drag-tooltip", "top-tooltip");
    leftTooltip.classList.add("block-drag-tooltip", "left-tooltip");
    bottomTooltip.classList.add("block-drag-tooltip", "right-tooltip");
    rightTooltip.classList.add("block-drag-tooltip", "bottom-tooltip");

    dragElement.setAttribute("contenteditable", "false");
    leftWidthElement.setAttribute("contenteditable", "false");
    rightWidthElement.setAttribute("contenteditable", "false");
    topHeightElement.setAttribute("contenteditable", "false");
    bottomHeightElement.setAttribute("contenteditable", "false");
    topLeftElement.setAttribute("contenteditable", "false");
    topRightElement.setAttribute("contenteditable", "false");
    bottomRightElement.setAttribute("contenteditable", "false");
    bottomLeftElement.setAttribute("contenteditable", "false");
    topTooltip.setAttribute("contenteditable", "false");
    leftTooltip.setAttribute("contenteditable", "false");
    bottomTooltip.setAttribute("contenteditable", "false");
    rightTooltip.setAttribute("contenteditable", "false");

    dragElement.innerHTML =
      '<svg class="block-drag-handle-svg" width="1200pt" height="1200pt" version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg"> <path d="m476.51 214.01 85.988-85.969v284.46c0 20.699 16.781 37.5 37.5 37.5 20.699 0 37.5-16.801 37.5-37.5v-284.46l85.988 85.969c7.332 7.332 16.91 10.988 26.512 10.988s19.18-3.6562 26.512-10.988c14.645-14.645 14.645-38.383 0-53.023l-150-150c-14.645-14.645-38.383-14.645-53.023 0l-150 150c-14.645 14.645-14.645 38.383 0 53.023 14.645 14.645 38.379 14.645 53.023 0z" fill="#1c9bf1"/> <path d="m723.49 985.99-85.988 85.969v-284.46c0-20.699-16.801-37.5-37.5-37.5-20.719 0-37.5 16.801-37.5 37.5v284.46l-85.988-85.969c-14.645-14.645-38.383-14.645-53.023 0-14.645 14.645-14.645 38.383 0 53.023l150 150c7.332 7.332 16.91 10.988 26.512 10.988s19.18-3.6562 26.512-10.988l150-150c14.645-14.645 14.645-38.383 0-53.023-14.645-14.645-38.379-14.645-53.023 0z" fill="#1c9bf1"/> <path d="m128.02 637.5h284.48c20.699 0 37.5-16.801 37.5-37.5s-16.801-37.5-37.5-37.5h-284.48l85.988-85.988c14.645-14.645 14.645-38.383 0-53.023-14.645-14.645-38.383-14.645-53.023 0l-150 150c-14.645 14.645-14.645 38.383 0 53.023l150 150c7.332 7.332 16.91 10.988 26.512 10.988s19.18-3.6562 26.512-10.988c14.645-14.645 14.645-38.383 0-53.023z" fill="#1c9bf1"/> <path d="m1189 573.49-150-150c-14.645-14.645-38.383-14.645-53.023 0-14.645 14.645-14.645 38.383 0 53.023l85.988 85.988h-284.48c-20.719 0-37.5 16.801-37.5 37.5s16.781 37.5 37.5 37.5h284.48l-85.988 85.988c-14.645 14.645-14.645 38.383 0 53.023 7.332 7.332 16.91 10.988 26.512 10.988s19.18-3.6562 26.512-10.988l150-150c14.645-14.645 14.645-38.379 0-53.023z" fill="#1c9bf1"/> <path d="m573.56 573.56c-7.125 6.9375-11.062 16.5-11.062 26.438s3.9375 19.5 11.062 26.438c6.9375 7.125 16.5 11.062 26.438 11.062s19.5-3.9375 26.438-11.062c7.125-6.9375 11.062-16.5 11.062-26.438 0-9.75-3.9375-19.5-11.062-26.438-13.875-14.062-39-14.062-52.875 0z" fill="#1c9bf1"/> </svg>';

    draggableContent.setAttribute("tabindex", "0");

    // Global keyboard event handlers for aspect ratio and grid snapping
    const globalKeyDown = (e) => {
      if (e.key === "Alt") {
        if (!snapToGrid) {
          snapToGrid = true;
          handleGrid(true);
        }
      }
      if (e.key === "Shift" || e.key === "shift") {
        if (!lockAspectRatio && target) {
          lockAspectRatio = true;
          // Calculate aspect ratio immediately when shift is pressed
        }
      }
    };

    const globalKeyUp = (e) => {
      if (e.key === "Alt") {
        if (snapToGrid) {
          snapToGrid = false;
          handleGrid(false);
        }
        clearTooltips();
      }
    };

    // Set position and dimensions on load
    requestAnimationFrame(() => {
      // target = draggableWrapper.closest(".ce-block");
      target = prototypeWrapper.closest(".ce-block");

      if (this.data?.draggable) {
        if (target) {
          let style = { ...this.data.draggable };
          const parseValue = (value) => {
            return typeof value === "string"
              ? parseInt(value.replace("px", ""))
              : value;
          };
          if (style.absolute) {
            target.style.position = "absolute";
            target.style.top = `${parseValue(style.top)}px`;
            target.style.left = `${parseValue(style.left)}px`;
          }
          if (style.width) {
            target.style.width = `${parseValue(style.width)}px`;
          }
          if (style.height) {
            target.style.height = `${parseValue(style.height)}px`;
          }
          if (style.group) {
            target.setAttribute("data-group", style.group);
          }
          if (style.hide) {
            target.setAttribute("data-hide", style.hide);
          }
          if (style.groupHide) {
            target.setAttribute("data-group-hide", style.groupHide);
          }
        }
      }
      this.globalKeyDown = globalKeyDown;
      this.globalKeyUp = globalKeyUp;
      // Add global keyboard listeners
      document.addEventListener("keydown", this.globalKeyDown);
      document.addEventListener("keyup", this.globalKeyUp);
    });

    const displayTooltips = (top, left, width, height) => {
      if (top !== undefined && top !== null) {
        topTooltip.innerText = `Y: ${top}`;
        if (!topTooltip.classList.contains("show")) {
          topTooltip.classList.add("show");
        }
        if (top < 40) {
          if (!topTooltip.classList.contains("inner")) {
            topTooltip.classList.add("inner");
          }
        } else {
          if (topTooltip.classList.contains("inner")) {
            topTooltip.classList.remove("inner");
          }
        }
      }

      if (left !== undefined && left !== null) {
        leftTooltip.innerText = `X: ${left}`;
        if (!leftTooltip.classList.contains("show")) {
          leftTooltip.classList.add("show");
        }
        if (top < 40) {
          if (!leftTooltip.classList.contains("inner")) {
            leftTooltip.classList.add("inner");
          }
        } else {
          if (leftTooltip.classList.contains("inner")) {
            leftTooltip.classList.remove("inner");
          }
        }
      }

      if (width !== undefined && width !== null) {
        rightTooltip.innerText = `W: ${width}`;
        if (!rightTooltip.classList.contains("show")) {
          rightTooltip.classList.add("show");
        }
        if (left + width > 1291) {
          if (!rightTooltip.classList.contains("inner")) {
            rightTooltip.classList.add("inner");
          }
        } else {
          if (rightTooltip.classList.contains("inner")) {
            rightTooltip.classList.remove("inner");
          }
        }
      }

      if (height !== undefined && height !== null) {
        bottomTooltip.innerText = `H: ${height}`;
        if (!bottomTooltip.classList.contains("show")) {
          bottomTooltip.classList.add("show");
        }
        if (top + height > 728) {
          if (!bottomTooltip.classList.contains("inner")) {
            bottomTooltip.classList.add("inner");
          }
        } else {
          if (bottomTooltip.classList.contains("inner")) {
            bottomTooltip.classList.remove("inner");
          }
        }
      }
    };

    const clearTooltips = () => {
      if (topTooltip.classList.contains("show")) {
        topTooltip.classList.remove("show");
      }
      if (leftTooltip.classList.contains("show")) {
        leftTooltip.classList.remove("show");
      }
      if (rightTooltip.classList.contains("show")) {
        rightTooltip.classList.remove("show");
      }
      if (bottomTooltip.classList.contains("show")) {
        bottomTooltip.classList.remove("show");
      }
      topTooltip.innerText = "";
      leftTooltip.innerText = "";
      rightTooltip.innerText = "";
      bottomTooltip.innerText = "";
    };

    const handleGrid = (_snapToGrid) => {
      let innerContainer = prototypeWrapper.closest(".inner-container");
      if (innerContainer) {
        if (_snapToGrid) {
          if (!innerContainer.classList.contains("grid")) {
            innerContainer.classList.add("grid");
          }
        } else {
          if (innerContainer.classList.contains("grid")) {
            innerContainer.classList.remove("grid");
          }
        }
      }
    };

    controlWrapper.appendChild(dragElement);
    controlWrapper.appendChild(leftWidthElement);
    controlWrapper.appendChild(rightWidthElement);
    controlWrapper.appendChild(topHeightElement);
    controlWrapper.appendChild(bottomHeightElement);
    controlWrapper.appendChild(topLeftElement);
    controlWrapper.appendChild(topRightElement);
    controlWrapper.appendChild(bottomRightElement);
    controlWrapper.appendChild(bottomLeftElement);
    draggableContent.append(blockContent);

    prototypeWrapper.append(topTooltip);
    prototypeWrapper.append(leftTooltip);
    prototypeWrapper.append(rightTooltip);
    prototypeWrapper.append(bottomTooltip);

    prototypeWrapper.appendChild(draggableContent);
    prototypeWrapper.append(controlWrapper);

    const interactEnd = async (_target, move) => {
      this.block.dispatchChange();

      if (
        move &&
        (_target.classList.contains("selected") ||
          _target.hasAttribute("data-group"))
      ) {
        const targetParent = _target.parentElement;
        const allBlocks = targetParent.querySelectorAll(".ce-block.selected");
        for (const block of allBlocks) {
          const blockId = block.getAttribute("data-id");
          const blockAPI = this.api.blocks.getById(blockId);

          if (blockAPI) {
            blockAPI.dispatchChange();
          }
        }
        if (!target.closest("section").classList.contains("select-mode")) {
          allBlocks.forEach((block) => block.classList.remove("selected"));
        }
      }
    };

    controlWrapper.addEventListener(
      "pointerdown",
      (e) => {
        e.preventDefault();
      },
      { capture: true }
    );

    prototypeWrapper.addEventListener("mouseenter", () => {
      const block = prototypeWrapper.closest(".ce-block");
      const slide = prototypeWrapper.closest("section");
      if (block && slide) {
        if (block.hasAttribute("data-group")) {
          const groupId = block.getAttribute("data-group");
          const groupBlocks = slide.querySelectorAll(
            `[data-group="${groupId}"]`,
          );
          groupBlocks.forEach((groupBlock) => {
            if (!groupBlock.classList.contains("show-group")) {
              groupBlock.classList.add("show-group");
            }
          });
        }
      }
    });

    prototypeWrapper.addEventListener("mouseleave", () => {
      const block = prototypeWrapper.closest(".ce-block");
      const slide = prototypeWrapper.closest("section");
      if (block && slide) {
        const allBlocks = slide.querySelectorAll(".ce-block[data-group]");
        allBlocks.forEach((block) => {
          block.classList.remove("show-group");
        });
      }
    });

    interact(prototypeWrapper)
      .draggable({
        allowFrom: ".draggable-controls",
        ignoreFrom: ".draggable-content, .locked, [data-group]:not(.focused)",
        inertia: false,
        // modifiers: [
        //   interact.modifiers.restrictRect({
        //     restriction: ".slide",
        //     endOnly: true,
        //   }),
        // ],
        listeners: {
          start(event) {
            const target = event.target.closest(".ce-block");
            const slide = target.closest(".slide");
            const setPosition = (blockArr) => {
              blockArr.forEach((targetBlock) => {
                if (
                  targetBlock.dataset.x == null ||
                  targetBlock.dataset.y == null
                ) {
                  const targetRect = targetBlock.getBoundingClientRect();
                  const slideRect = slide.getBoundingClientRect();

                  targetBlock.dataset.x = targetRect.left - slideRect.left;
                  targetBlock.dataset.y = targetRect.top - slideRect.top;
                }
              });
            };

            if (target.classList.contains("selected")) {
              const selectedBlocks =
                slide.querySelectorAll(".ce-block.selected");
              setPosition(selectedBlocks);
            } else {
              target.classList.add("dragging");

              if (target.dataset.x == null || target.dataset.y == null) {
                const targetRect = target.getBoundingClientRect();
                const slideRect = slide.getBoundingClientRect();

                target.dataset.x = targetRect.left - slideRect.left;
                target.dataset.y = targetRect.top - slideRect.top;
              }
            }
          },
          move(event) {
            const target = event.target.closest(".ce-block");
            const slide = target.closest(".slide");

            const blocksToMove = target.classList.contains("selected")
              ? Array.from(slide.querySelectorAll(".ce-block.selected"))
              : [target];

            blocksToMove.forEach((block) => {
              if (!block.snapOffset) block.snapOffset = { x: 0, y: 0 };

              block.snapOffset.x += event.dx;
              block.snapOffset.y += event.dy;

              let x = parseFloat(block.dataset.x) + block.snapOffset.x;
              let y = parseFloat(block.dataset.y) + block.snapOffset.y;

              // Alt-key snapping
              if (event.altKey) {
                const snappedX = Math.round(x / gridSize) * gridSize;
                const snappedY = Math.round(y / gridSize) * gridSize;

                // Only update offset when a grid step has been crossed
                block.snapOffset.x -= snappedX - parseFloat(block.dataset.x);
                block.snapOffset.y -= snappedY - parseFloat(block.dataset.y);

                x = snappedX;
                y = snappedY;
              } else {
                block.snapOffset.x = 0;
                block.snapOffset.y = 0;
              }

              // Apply position
              block.style.left = `${x}px`;
              block.style.top = `${y}px`;

              block.dataset.x = x;
              block.dataset.y = y;
            });

            displayTooltips(
              parseInt(target.dataset.y),
              parseInt(target.dataset.x),
              null,
              null,
            );
          },
          end(event) {
            const target = event.target.closest(".ce-block");
            target.classList.remove("dragging");
            clearTooltips();
            interactEnd(target, true);
          },
        },
      })
      .resizable({
        allowFrom: ".edge-handle, .corner-handle",
        ignoreFrom: ".locked, .draggable-content, .editor-block-toolbar",
        edges: { left: true, right: true, top: true, bottom: true },
        listeners: {
          start(event) {
            const target = event.target.closest(".ce-block");
            const rect = target.getBoundingClientRect();
            const slide = target.closest(".slide");

            if (target.dataset.x == null || target.dataset.y == null) {
              const targetRect = target.getBoundingClientRect();
              const slideRect = slide.getBoundingClientRect();

              target.dataset.x = targetRect.left - slideRect.left;
              target.dataset.y = targetRect.top - slideRect.top;
            }

            const left = parseFloat(target.dataset.x);
            const top = parseFloat(target.dataset.y);

            target._resizeState = {
              startX: event.client.x,
              startY: event.client.y,
              width: rect.width,
              height: rect.height,
              left: left,
              top: top,
              aspectRatio: rect.width / rect.height,
              edges: { ...event.edges },
            };
          },
          move(event) {
            const target = event.target.closest(".ce-block");
            const s = target._resizeState;

            const dx = event.client.x - s.startX;
            const dy = event.client.y - s.startY;

            let width = s.width;
            let height = s.height;
            let left = s.left;
            let top = s.top;

            const { left: L, right: R, top: T, bottom: B } = s.edges;

            // --------------------
            // WIDTH
            // --------------------
            if (R) {
              width = s.width + dx;
            }

            if (L) {
              width = s.width - dx;
              left = s.left + dx;
            }

            // --------------------
            // HEIGHT
            // --------------------
            if (B) {
              height = s.height + dy;
            }

            if (T) {
              height = s.height - dy;
              top = s.top + dy;
            }

            // --------------------
            // ASPECT RATIO (Shift)
            // --------------------
            if (event.shiftKey) {
              const corner = (L || R) && (T || B);

              // --------------------
              // CORNERS (dominant axis, no centering)
              // --------------------
              if (corner) {
                const dominant = Math.abs(dx) > Math.abs(dy) ? "x" : "y";

                if (dominant === "x") {
                  width = L ? s.width - dx : s.width + dx;
                  height = width / s.aspectRatio;
                } else {
                  height = T ? s.height - dy : s.height + dy;
                  width = height * s.aspectRatio;
                }

                // Anchor opposite corner
                if (L) left = s.left + (s.width - width);
                if (T) top = s.top + (s.height - height);
              }

              // --------------------
              // EDGES (centered scaling)
              // --------------------
              else {
                if (L || R) {
                  height = width / s.aspectRatio;
                  top = s.top - (height - s.height) / 2;
                }

                if (T || B) {
                  width = height * s.aspectRatio;
                  left = s.left - (width - s.width) / 2;
                }
              }
            }

            // --------------------
            // SNAP (Alt)
            // --------------------
            if (event.altKey) {
              const g = 5;
              width = Math.round(width / g) * g;
              height = Math.round(height / g) * g;
              left = Math.round(left / g) * g;
              top = Math.round(top / g) * g;
            }

            // --------------------
            // APPLY
            // --------------------
            target.style.position = "absolute";
            target.style.width = `${width}px`;
            target.style.height = `${height}px`;
            target.style.left = `${left}px`;
            target.style.top = `${top}px`;

            target.dataset.x = left;
            target.dataset.y = top;
            displayTooltips(
              parseInt(top),
              parseInt(left),
              parseInt(width),
              parseInt(height),
            );
          },
          end(event) {
            const target = event.target.closest(".ce-block");
            clearTooltips();
            interactEnd(target);
          },
        },
      })
      .on("tap", (event) => {
        const slideSection = event.currentTarget.closest("section.slide-wrap");
        if (!slideSection.classList.contains("select-mode")) {
          const target = event.currentTarget.closest(".ce-block");
          const handleExitEdit = (e) => {
            if (!target.contains(e.target)) {
              exitEditMode();
            }
          };

          const exitEditMode = () => {
            target.classList.remove("hide-drag-handle");
            window.removeEventListener("pointerdown", handleExitEdit, true);
          };

          if (target.classList.contains("embed")) {
            target.focus();
          }

          target.setAttribute("tabindex", "0");
          target.classList.add("hide-drag-handle");
          window.addEventListener("pointerdown", handleExitEdit, true);
        }
      })
      // .on("down", (event) => {
      //   event.preventDefault();
      // });

    return prototypeWrapper;
  }

  lockSwitch(_locked) {
    if (_locked) {
      if (this.draggableWrapper) {
        if (!this.draggableWrapper.classList.contains("locked")) {
          this.draggableWrapper.classList.add("locked");
        }
      }
      return {
        icon: LockIcon,
        label: "Unlock",
      };
    } else {
      if (this.draggableWrapper) {
        if (this.draggableWrapper.classList.contains("locked")) {
          this.draggableWrapper.classList.remove("locked");
        }
      }
      return {
        icon: UnlockIcon,
        label: "Lock",
      };
    }
  }

  renderLockBtn() {
    const lockBtnContainer = document.createElement("button");
    const lockBtnIcon = document.createElement("div");
    const lockBtnLabel = document.createElement("div");

    lockBtnContainer.classList.add("cdx-draggable-lock-btn-container");
    lockBtnIcon.classList.add("cdx-draggable-lock-btn-icon");
    lockBtnLabel.classList.add("cdx-draggable-lock-btn-label");

    lockBtnIcon.innerHTML = this.lockSwitch(this.locked).icon;
    lockBtnLabel.innerHTML = this.lockSwitch(this.locked).label;

    lockBtnContainer.appendChild(lockBtnIcon);
    lockBtnContainer.appendChild(lockBtnLabel);

    lockBtnContainer.addEventListener("click", () => {
      this.locked = !this.locked;
      lockBtnIcon.innerHTML = this.lockSwitch(this.locked).icon;
      lockBtnLabel.innerHTML = this.lockSwitch(this.locked).label;
      this.data.draggable.locked = this.locked;
      // this.block.dispatchChange();
    });

    return lockBtnContainer;
  }

  render() {
    const draggableSettings = document.createElement("div");
    const settingsLabel = document.createElement("label");
    draggableSettings.classList.add("draggable-lock-tune", "editor-block-tune");
    settingsLabel.classList.add("editor-block-tune-title");
    settingsLabel.innerText = "Draggable";

    draggableSettings.appendChild(settingsLabel);
    draggableSettings.appendChild(this.renderLockBtn());

    const index = this.api.blocks.getCurrentBlockIndex();

    this.api.blocks.setDraggable(index, true);

    return draggableSettings;
  }

  destroy() {
    document.removeEventListener("keydown", this.globalKeyDown);
    document.removeEventListener("keyup", this.globalKeyUp);
  }

  getData() {
    const block = this.wrapper.closest(".ce-block");
    const slide = this.wrapper.closest("section");
    const blockRect = block.getBoundingClientRect();
    const slideRect = slide.getBoundingClientRect();
    const top = blockRect.top - slideRect.top;
    const left = blockRect.left - slideRect.left;

    this.data.draggable = {
      absolute: block.style.absolute || "absolute",
      top: top,
      left: left,
      width: blockRect.width,
      height: blockRect.height,
      locked: this.locked,
      group: block.getAttribute("data-group") || null,
      hide: block.getAttribute("data-hide") || null,
      groupHide: block.getAttribute("data-group-hide") || null,
    };
  }

  save() {
    this.getData();
    return this.data;
  }
}
